module.exports = __webpack_public_path__ + "img/SB.2c776db7.svg";